const DietData = [
    {
        image: "./images/diet/apple.jpeg",
        type: "vegeatarian",
        name: "apple",
        time: "early morning",
        calories: 53,
        carbohydrates_total_g: 14.1,
        cholesterol_mg: 0,
        fat_saturated_g: 0,
        fat_total_g: 0.2,
        fiber_g: 2.4,
        potassium_mg: 11,
        protein_g: 0.3,
        serving_size_g: 100,
        sodium_mg: 1,
        sugar_g: 10.3,
        id: 0,
    },
    {
        image: "./images/diet/lemon honey water.jpeg",
        type: "vegeatarian",
        name: "lemon honey water",
        time: "early morning",
        calories: 30.7,
        carbohydrates_total_g: 8.5,
        cholesterol_mg: 0,
        fat_saturated_g: 0,
        fat_total_g: 0.3,
        fiber_g: 0.03,
        potassium_mg: 4,
        protein_g: 0.03,
        serving_size_g: 100,
        sodium_mg: 0.3,
        sugar_g: 8.3,
        id: 1,
    },
    {
        image: "./images/diet/low fat milk.jpeg",
        type: "vegeatarian",
        name: "low fat milk",
        time: "early morning",
        calories: 42.6,
        carbohydrates_total_g: 4.9,
        cholesterol_mg: 5,
        fat_saturated_g: 0.6,
        fat_total_g: 1,
        fiber_g: 0,
        potassium_mg: 93,
        protein_g: 3.4,
        serving_size_g: 100,
        sodium_mg: 43,
        sugar_g: 5.2,
        id: 2,
    },
    {
        image: "./images/diet/soaked dry fruits (mixed).jpeg",
        type: "vegeatarian",
        name: "soaked dry fruits (mixed)",
        time: "early morning",
        calories: 520,
        carbohydrates_total_g: 45,
        cholesterol_mg: 0,
        fat_saturated_g: 6,
        fat_total_g: 34,
        fiber_g: 6.8,
        potassium_mg: 600,
        protein_g: 12,
        serving_size_g: 100,
        sodium_mg: 8,
        sugar_g: 30,
        id: 3,
    },
    {
        image: "./images/diet/Kalonji seeds water.jpeg",
        type: "vegeatarian",
        name: "Kalonji seeds water",
        time: "early morning",
        calories: 375,
        carbohydrates_total_g: 44.24,
        cholesterol_mg: 0,
        fat_saturated_g: 1.5,
        fat_total_g: 22.27,
        fiber_g: 10.5,
        potassium_mg: 1788,
        protein_g: 17.81,
        serving_size_g: 100,
        sodium_mg: 168,
        sugar_g: 2.25,
        id: 4,
    },
    {
        image: "./images/diet/cinnamon water.jpeg",
        type: "vegeatarian",
        name: "cinnamon water",
        time: "early morning",
        calories: 1,
        carbohydrates_total_g: 0.3,
        cholesterol_mg: 0,
        fat_saturated_g: 0,
        fat_total_g: 0,
        fiber_g: 0.1,
        potassium_mg: 3,
        protein_g: 0,
        serving_size_g: 100,
        sodium_mg: 1,
        sugar_g: 0,
        id: 5,
    },
    {
        image: "./images/diet/raisin_water.jpeg",
        type: "vegeatarian",
        name: "raisin_water",
        time: "early morning",
        calories: 63,
        carbohydrates_total_g: 17,
        cholesterol_mg: 0,
        fat_saturated_g: 0,
        fat_total_g: 0,
        fiber_g: 0.6,
        potassium_mg: 125,
        protein_g: 0.5,
        serving_size_g: 100,
        sodium_mg: 4,
        sugar_g: 16,
        id: 6,
    },
    {
        image: "./images/diet/beetroot juice.jpeg",
        type: "vegeatarian",
        name: "beetroot juice",
        time: "break fast",
        calories: 43,
        carbohydrates_total_g: 10,
        cholesterol_mg: 0,
        fat_saturated_g: 0,
        fat_total_g: 0.1,
        fiber_g: 0.5,
        protein_g: 1,
        potassium_mg: 325,
        sodium_mg: 77,
        sugar_g: 7,
        serving_size_g: 100,
        id: 7,
    },
    {
        image: "./images/diet/peanut butter milkshake.jpeg",
        type: "vegeatarian",
        name: "peanut butter milkshake",
        time: "break fast",
        calories: 175,
        carbohydrates_total_g: 18,
        cholesterol_mg: 8,
        fat_saturated_g: 3,
        fat_total_g: 10,
        fiber_g: 2,
        protein_g: 7,
        potassium_mg: 250,
        sodium_mg: 120,
        sugar_g: 12,
        serving_size_g: 100,
        id: 8,
    },
    {
        image: "./images/diet/curd.jpeg",
        type: "vegeatarian",
        name: "curd",
        time: "break fast",
        calories: 98,
        carbohydrates_total_g: 4,
        cholesterol_mg: 17,
        fat_saturated_g: 3,
        fat_total_g: 5,
        fiber_g: 0,
        protein_g: 10,
        potassium_mg: 175,
        sodium_mg: 50,
        sugar_g: 4,
        serving_size_g: 100,
        id: 9,
    },
    {
        image: "./images/diet/whey protein powder.jpeg",
        type: "vegeatarian",
        name: "whey protein powder",
        time: "break fast",
        calories: 400,
        carbohydrates_total_g: 12,
        cholesterol_mg: 70,
        fat_saturated_g: 2.5,
        fat_total_g: 7,
        fiber_g: 1,
        protein_g: 75,
        potassium_mg: 650,
        sodium_mg: 300,
        sugar_g: 4,
        serving_size_g: 100,
        id: 10,
    },
    {
        image: "./images/diet/veggie_protein_boost.jpeg",
        type: "vegeatarian",
        name: "veggie_protein_boost",
        time: "break fast",
        calories: 150,
        carbohydrates_total_g: 10,
        cholesterol_mg: 0,
        fat_saturated_g: 0.5,
        fat_total_g: 3,
        fiber_g: 4.5,
        potassium_mg: 400,
        protein_g: 20,
        serving_size_g: 100,
        sodium_mg: 15,
        sugar_g: 2,
        id: 11,
    },
    {
        image: "./images/diet/boiled_chicken_breast.jpeg",
        type: "nonvegeatarian",
        name: "boiled_chicken_breast",
        time: "break fast",
        calories: 165,
        carbohydrates_total_g: 0,
        cholesterol_mg: 85,
        fat_saturated_g: 1.2,
        fat_total_g: 3.6,
        fiber_g: 0,
        potassium_mg: 256,
        protein_g: 31,
        serving_size_g: 100,
        sodium_mg: 74,
        sugar_g: 0,
        id: 12,
    },
    {
        image: "./images/diet/brown_bread.jpeg",
        type: "vegeatarian",
        name: "brown_bread",
        time: "break fast",
        calories: 247,
        carbohydrates_total_g: 41.5,
        cholesterol_mg: 0,
        fat_saturated_g: 0.7,
        fat_total_g: 3.6,
        fiber_g: 6,
        potassium_mg: 230,
        protein_g: 8,
        serving_size_g: 100,
        sodium_mg: 400,
        sugar_g: 5,
        id: 13,
    },
    {
        image: "./images/diet/besan_chilla_cooked.jpeg",
        type: "vegeatarian",
        name: "besan_chilla_cooked",
        time: "break fast",
        calories: 150,
        carbohydrates_total_g: 22,
        cholesterol_mg: 0,
        fat_saturated_g: 0.5,
        fat_total_g: 3.5,
        fiber_g: 5,
        potassium_mg: 150,
        protein_g: 7,
        serving_size_g: 100,
        sodium_mg: 300,
        sugar_g: 1,
        id: 14,
    },
    {
        image: "./images/diet/poha_cooked.jpeg",
        type: "vegeatarian",
        name: "poha_cooked",
        time: "break fast",
        calories: 130,
        carbohydrates_total_g: 28.3,
        cholesterol_mg: 0,
        fat_saturated_g: 0.5,
        fat_total_g: 3,
        fiber_g: 1.5,
        potassium_mg: 85,
        protein_g: 2.2,
        serving_size_g: 100,
        sodium_mg: 5,
        sugar_g: 0.3,
        id: 15,
    },
    {
        image: "./images/diet/fruit_salad.jpeg",
        type: "vegeatarian",
        name: "fruit_salad",
        time: "break fast",
        calories: 50,
        carbohydrates_total_g: 13,
        cholesterol_mg: 0,
        fat_saturated_g: 0.1,
        fat_total_g: 0.2,
        fiber_g: 2.5,
        potassium_mg: 150,
        protein_g: 0.6,
        serving_size_g: 100,
        sodium_mg: 1,
        sugar_g: 9,
        id: 16,
    },
    {
        image: "./images/diet/scrambled_eggs_with_dry_fruits.jpeg",
        type: "eggeatarian",
        name: "scrambled_eggs_with_dry_fruits",
        time: "break fast",
        calories: 185,
        carbohydrates_total_g: 5,
        cholesterol_mg: 370,
        fat_saturated_g: 5,
        fat_total_g: 14,
        fiber_g: 1.5,
        potassium_mg: 150,
        protein_g: 10,
        serving_size_g: 100,
        sodium_mg: 140,
        sugar_g: 3,
        id: 17,
    },
    {
        image: "./images/diet/boiled_eggs.jpeg",
        type: "eggeatarian",
        name: "boiled_eggs",
        time: "break fast",
        calories: 155,
        carbohydrates_total_g: 1.1,
        cholesterol_mg: 373,
        fat_saturated_g: 3.3,
        fat_total_g: 11,
        fiber_g: 0,
        potassium_mg: 126,
        protein_g: 13,
        serving_size_g: 100,
        sodium_mg: 124,
        sugar_g: 1.1,
        id: 18,
    },
    {
        image: "./images/diet/egg_omelet_with_brown_bread.jpeg",
        type: "eggeatarian",
        name: "egg_omelet_with_brown_bread",
        time: "break fast",
        calories: 196,
        carbohydrates_total_g: 15,
        cholesterol_mg: 195,
        fat_saturated_g: 3,
        fat_total_g: 11,
        fiber_g: 2.2,
        potassium_mg: 160,
        protein_g: 10,
        serving_size_g: 100,
        sodium_mg: 330,
        sugar_g: 2,
        id: 19,
    },
    {
        image: "./images/diet/hummus_with_brown_bread.jpeg",
        type: "vegeatarian",
        name: "hummus_with_brown_bread",
        time: "break fast",
        calories: 220,
        carbohydrates_total_g: 28,
        cholesterol_mg: 0,
        fat_saturated_g: 1.5,
        fat_total_g: 9,
        fiber_g: 5,
        potassium_mg: 180,
        protein_g: 7,
        serving_size_g: 100,
        sodium_mg: 300,
        sugar_g: 2,
        id: 20,
    },
    {
        image: "./images/diet/oats_with_fruits.jpeg",
        type: "vegeatarian",
        name: "oats_with_fruits",
        time: "break fast",
        calories: 120,
        carbohydrates_total_g: 21,
        cholesterol_mg: 0,
        fat_saturated_g: 0.5,
        fat_total_g: 2.5,
        fiber_g: 3.5,
        potassium_mg: 150,
        protein_g: 3.2,
        serving_size_g: 100,
        sodium_mg: 2,
        sugar_g: 6,
        id: 21,
    },
    {
        image: "./images/diet/oats.jpeg",
        type: "vegeatarian",
        name: "oats",
        time: "break fast",
        calories: 389,
        carbohydrates_total_g: 66.3,
        cholesterol_mg: 0,
        fat_saturated_g: 1.2,
        fat_total_g: 6.9,
        fiber_g: 10.6,
        potassium_mg: 429,
        protein_g: 16.9,
        serving_size_g: 100,
        sodium_mg: 2,
        sugar_g: 0.9,
        id: 22,
    },
    {
        image: "./images/diet/ragi_upma.jpeg",
        type: "vegeatarian",
        name: "ragi_upma",
        time: "break fast",
        calories: 119,
        carbohydrates_total_g: 20,
        cholesterol_mg: 0,
        fat_saturated_g: 0.5,
        fat_total_g: 3.5,
        fiber_g: 2.7,
        potassium_mg: 130,
        protein_g: 2.5,
        serving_size_g: 100,
        sodium_mg: 150,
        sugar_g: 1.2,
        id: 23,
    },
    {
        image: "./images/diet/protein_milk.jfif",
        type: "vegeatarian",
        name: "protein_milk",
        time: "break fast",
        calories: 60,
        carbohydrates_total_g: 4.8,
        cholesterol_mg: 5,
        fat_saturated_g: 1.2,
        fat_total_g: 3.2,
        fiber_g: 0,
        potassium_mg: 150,
        protein_g: 6,
        serving_size_g: 100,
        sodium_mg: 45,
        sugar_g: 4.8,
        id: 24,
    },
    {
        image: "./images/diet/yogurt_dry_fruit_bowl.jfif",
        type: "vegeatarian",
        name: "yogurt_dry_fruit_bowl",
        time: "break fast",
        calories: 165,
        carbohydrates_total_g: 18,
        cholesterol_mg: 8,
        fat_saturated_g: 3,
        fat_total_g: 6,
        fiber_g: 1.5,
        potassium_mg: 250,
        protein_g: 6,
        serving_size_g: 100,
        sodium_mg: 40,
        sugar_g: 12,
        id: 25,
    },
    {
        image: "./images/diet/cooked_chapati.jpg",
        type: "vegeatarian",
        name: "cooked_chapati",
        time: "lunch",
        calories: 187,
        carbohydrates_total_g: 30.3,
        cholesterol_mg: 0,
        fat_saturated_g: 0.5,
        fat_total_g: 3.1,
        fiber_g: 4.9,
        potassium_mg: 170,
        protein_g: 5.1,
        serving_size_g: 100,
        sodium_mg: 298,
        sugar_g: 0.4,
        id: 26,
    },
    {
        image: "./images/diet/cooked_dal.jpg",
        type: "vegeatarian",
        name: "cooked_dal",
        time: "lunch",
        calories: 116,
        carbohydrates_total_g: 19,
        cholesterol_mg: 0,
        fat_saturated_g: 0.2,
        fat_total_g: 3.3,
        fiber_g: 7.8,
        potassium_mg: 369,
        protein_g: 7.6,
        serving_size_g: 100,
        sodium_mg: 5,
        sugar_g: 1.8,
        id: 27,
    },
    {
        image: "./images/diet/mixed vegetables.jpg",
        type: "vegeatarian",
        name: "mixed vegetables",
        time: "lunch",
        calories: 60,
        carbohydrates_total_g: 12,
        cholesterol_mg: 0,
        fat_saturated_g: 0.3,
        fat_total_g: 1,
        fiber_g: 4,
        protein_g: 3,
        potassium_mg: 300,
        sodium_mg: 75,
        sugar_g: 4,
        serving_size_g: 100,
        id: 28,
    },
    {
        image: "./images/diet/palak paratha with curd.jfif",
        type: "vegeatarian",
        name: "palak paratha with curd",
        time: "lunch",
        calories: 160,
        carbohydrates_total_g: 22,
        cholesterol_mg: 10,
        fat_saturated_g: 1.5,
        fat_total_g: 5,
        fiber_g: 3,
        protein_g: 8,
        potassium_mg: 200,
        sodium_mg: 100,
        sugar_g: 2,
        serving_size_g: 100,
        id: 29,
    },
    {
        image: "./images/diet/dal rice.jpg",
        type: "vegeatarian",
        name: "dal rice",
        time: "lunch",
        calories: 140,
        carbohydrates_total_g: 27,
        cholesterol_mg: 0,
        fat_saturated_g: 0.3,
        fat_total_g: 1.8,
        fiber_g: 3,
        protein_g: 5,
        potassium_mg: 200,
        sodium_mg: 7,
        sugar_g: 1,
        serving_size_g: 100,
        id: 30,
    },
    {
        image: "./images/diet/bajra bhakri.jfif",
        type: "vegeatarian",
        name: "bajra bhakri",
        time: "lunch",
        calories: 240,
        carbohydrates_total_g: 48,
        cholesterol_mg: 0,
        fat_saturated_g: 0.5,
        fat_total_g: 4.5,
        fiber_g: 6,
        protein_g: 8,
        potassium_mg: 175,
        sodium_mg: 7,
        sugar_g: 0.8,
        serving_size_g: 100,
        id: 31,
    },
    {
        image: "./images/diet/palak_kadhi_with_brown_rice.jfif",
        type: "vegeatarian",
        name: "palak_kadhi_with_brown_rice",
        time: "lunch",
        calories: 95,
        carbohydrates_total_g: 13.5,
        cholesterol_mg: 3,
        fat_saturated_g: 1,
        fat_total_g: 3.5,
        fiber_g: 2.2,
        potassium_mg: 210,
        protein_g: 3.8,
        serving_size_g: 100,
        sodium_mg: 160,
        sugar_g: 2.5,
        id: 32,
    },
    {
        image: "./images/diet/soya_chunks_gravy_with_chapati.jpg",
        type: "vegeatarian",
        name: "soya_chunks_gravy_with_chapati",
        time: "lunch",
        calories: 280,
        carbohydrates_total_g: 32,
        cholesterol_mg: 0,
        fat_saturated_g: 1.8,
        fat_total_g: 8,
        fiber_g: 6,
        potassium_mg: 400,
        protein_g: 18,
        serving_size_g: 200,
        sodium_mg: 240,
        sugar_g: 4,
        id: 33,
    },
    {
        image: "./images/diet/paneer_bhurji_with_chapati.jfif",
        type: "vegeatarian",
        name: "paneer_bhurji_with_chapati",
        time: "lunch",
        calories: 320,
        carbohydrates_total_g: 22,
        cholesterol_mg: 25,
        fat_saturated_g: 6,
        fat_total_g: 18,
        fiber_g: 3,
        potassium_mg: 250,
        protein_g: 14,
        serving_size_g: 200,
        sodium_mg: 380,
        sugar_g: 4,
        id: 34,
    },
    {
        image: "./images/diet/paneer_vegetable_besan_kadhi_with_brown_rice_and_curd.jfif",
        type: "vegeatarian",
        name: "paneer_vegetable_besan_kadhi_with_brown_rice_and_curd",
        time: "lunch",
        calories: 450,
        carbohydrates_total_g: 55,
        cholesterol_mg: 25,
        fat_saturated_g: 7,
        fat_total_g: 18,
        fiber_g: 6,
        potassium_mg: 500,
        protein_g: 18,
        serving_size_g: 350,
        sodium_mg: 300,
        sugar_g: 8,
        id: 35,
    },
    {
        image: "./images/diet/egg_curry.jfif",
        type: "eggeatarian",
        name: "egg_curry",
        time: "lunch",
        calories: 150,
        carbohydrates_total_g: 5.5,
        cholesterol_mg: 190,
        fat_saturated_g: 3,
        fat_total_g: 10,
        fiber_g: 1.2,
        potassium_mg: 180,
        protein_g: 10,
        serving_size_g: 100,
        sodium_mg: 350,
        sugar_g: 2,
        id: 36,
    },
    {
        image: "./images/diet/chicken_salad.jfif",
        type: "nonvegeatarian",
        name: "chicken_salad",
        time: "lunch",
        calories: 170,
        carbohydrates_total_g: 3.2,
        cholesterol_mg: 55,
        fat_saturated_g: 2.2,
        fat_total_g: 10.1,
        fiber_g: 0.8,
        potassium_mg: 220,
        protein_g: 16.5,
        serving_size_g: 100,
        sodium_mg: 320,
        sugar_g: 1.2,
        id: 37,
    },
    {
        image: "./images/diet/chicken_kebab.jfif",
        type: "nonvegeatarian",
        name: "chicken_kebab",
        time: "lunch",
        calories: 180,
        carbohydrates_total_g: 2.5,
        cholesterol_mg: 85,
        fat_saturated_g: 3.5,
        fat_total_g: 8,
        fiber_g: 0.5,
        potassium_mg: 270,
        protein_g: 20,
        serving_size_g: 100,
        sodium_mg: 400,
        sugar_g: 1,
        id: 38,
    },
    {
        image: "./images/diet/low_fat_chicken_biryani.jfif",
        type: "nonvegeatarian",
        name: "low_fat_chicken_biryani",
        time: "lunch",
        calories: 150,
        carbohydrates_total_g: 20.5,
        cholesterol_mg: 30,
        fat_saturated_g: 2.5,
        fat_total_g: 5,
        fiber_g: 1.8,
        potassium_mg: 200,
        protein_g: 12.5,
        serving_size_g: 100,
        sodium_mg: 250,
        sugar_g: 1,
        id: 39,
    },
    {
        image: "./images/diet/bhuna chana.jfif",
        type: "vegeatarian",
        name: "bhuna chana",
        time: "snaks",
        calories: 365,
        carbohydrates_total_g: 58,
        cholesterol_mg: 0,
        fat_saturated_g: 0.7,
        fat_total_g: 6.5,
        fiber_g: 16,
        protein_g: 20,
        potassium_mg: 850,
        sodium_mg: 12,
        sugar_g: 11,
        serving_size_g: 100,
        id: 40,
    },
    {
        image: "./images/diet/boiled corn.jfif",
        type: "vegeatarian",
        name: "boiled corn",
        time: "snaks",
        calories: 96,
        carbohydrates_total_g: 21,
        cholesterol_mg: 0,
        fat_saturated_g: 0.2,
        fat_total_g: 1.5,
        fiber_g: 2.5,
        protein_g: 3.5,
        potassium_mg: 250,
        sodium_mg: 5,
        sugar_g: 4.5,
        serving_size_g: 100,
        id: 41,
    },
    {
        image: "./images/diet/coconut water.jfif",
        type: "vegeatarian",
        name: "coconut water",
        time: "snaks",
        calories: 19,
        carbohydrates_total_g: 4,
        cholesterol_mg: 0,
        fat_saturated_g: 0,
        fat_total_g: 0.2,
        fiber_g: 0,
        protein_g: 1,
        potassium_mg: 275,
        sodium_mg: 102,
        sugar_g: 3,
        serving_size_g: 100,
        id: 42,
    },
    {
        image: "./images/diet/makhana.jfif",
        type: "vegeatarian",
        name: "makhana",
        time: "snaks",
        calories: 375,
        carbohydrates_total_g: 67,
        cholesterol_mg: 0,
        fat_saturated_g: 0.2,
        fat_total_g: 1,
        fiber_g: 8,
        protein_g: 10,
        potassium_mg: 550,
        sodium_mg: 8,
        sugar_g: 1,
        serving_size_g: 100,
        id: 43,
    },
    {
        image: "./images/diet/rajma salad.jfif",
        type: "vegeatarian",
        name: "rajma salad",
        time: "snaks",
        calories: 130,
        carbohydrates_total_g: 24,
        cholesterol_mg: 0,
        fat_saturated_g: 0.3,
        fat_total_g: 1.5,
        fiber_g: 7,
        protein_g: 8,
        potassium_mg: 350,
        sodium_mg: 60,
        sugar_g: 3,
        serving_size_g: 100,
        id: 44,
    },
    {
        image: "./images/diet/egg_avocado_toast.jfif",
        type: "eggeatarian",
        name: "egg_avocado_toast",
        time: "snaks",
        calories: 160,
        carbohydrates_total_g: 8.5,
        cholesterol_mg: 0,
        fat_saturated_g: 2.1,
        fat_total_g: 14,
        fiber_g: 6.7,
        potassium_mg: 485,
        protein_g: 2,
        serving_size_g: 100,
        sodium_mg: 380,
        sugar_g: 1.3,
        id: 45,
    },
    {
        image: "./images/diet/almond_sandwich.jfif",
        type: "vegeatarian",
        name: "almond_sandwich",
        time: "snaks",
        calories: 250,
        carbohydrates_total_g: 24,
        cholesterol_mg: 0,
        fat_saturated_g: 3,
        fat_total_g: 18,
        fiber_g: 4,
        potassium_mg: 210,
        protein_g: 8,
        serving_size_g: 100,
        sodium_mg: 200,
        sugar_g: 4,
        id: 46,
    },
    {
        image: "./images/diet/celery_juice.jfif",
        type: "vegeatarian",
        name: "celery_juice",
        time: "snaks",
        calories: 16,
        carbohydrates_total_g: 3.6,
        cholesterol_mg: 0,
        fat_saturated_g: 0.1,
        fat_total_g: 0.2,
        fiber_g: 1.6,
        potassium_mg: 260,
        protein_g: 0.7,
        serving_size_g: 100,
        sodium_mg: 80,
        sugar_g: 1.8,
        id: 47,
    },
    {
        image: "./images/diet/dahi_paratha.jfif",
        type: "vegeatarian",
        name: "dahi_paratha",
        time: "dinner",
        calories: 210,
        carbohydrates_total_g: 30.5,
        cholesterol_mg: 20,
        fat_saturated_g: 5.2,
        fat_total_g: 9,
        fiber_g: 1.5,
        potassium_mg: 210,
        protein_g: 5.5,
        serving_size_g: 100,
        sodium_mg: 350,
        sugar_g: 2.5,
        id: 48,
    },
    {
        image: "./images/diet/tofu_bhurji_with_roti.jfif",
        type: "vegeatarian",
        name: "tofu_bhurji_with_roti",
        time: "dinner",
        calories: 170,
        carbohydrates_total_g: 15.2,
        cholesterol_mg: 0,
        fat_saturated_g: 4.8,
        fat_total_g: 9.6,
        fiber_g: 4.2,
        potassium_mg: 220,
        protein_g: 10.2,
        serving_size_g: 100,
        sodium_mg: 220,
        sugar_g: 3.2,
        id: 49,
    },
    {
        image: "./images/diet/high_protein_legume_salad.jfif",
        type: "vegeatarian",
        name: "high_protein_legume_salad",
        time: "dinner",
        calories: 120,
        carbohydrates_total_g: 15,
        cholesterol_mg: 0,
        fat_saturated_g: 0.5,
        fat_total_g: 3.5,
        fiber_g: 6.5,
        potassium_mg: 300,
        protein_g: 9,
        serving_size_g: 100,
        sodium_mg: 20,
        sugar_g: 3.5,
        id: 50,
    },
    {
        image: "./images/diet/spinach_vegetable_soup.jfif",
        type: "vegeatarian",
        name: "spinach_vegetable_soup",
        time: "dinner",
        calories: 23,
        carbohydrates_total_g: 3.6,
        cholesterol_mg: 0,
        fat_saturated_g: 0.1,
        fat_total_g: 0.3,
        fiber_g: 1.5,
        potassium_mg: 558,
        protein_g: 2.9,
        serving_size_g: 100,
        sodium_mg: 333,
        sugar_g: 1,
        id: 51,
    },
    {
        image: "./images/diet/chicken_mushroom_salad.jfif",
        type: "nonvegeatarian",
        name: "chicken_mushroom_salad",
        time: "dinner",
        calories: 120,
        carbohydrates_total_g: 5.4,
        cholesterol_mg: 40,
        fat_saturated_g: 2.5,
        fat_total_g: 6,
        fiber_g: 2,
        potassium_mg: 250,
        protein_g: 15,
        serving_size_g: 100,
        sodium_mg: 350,
        sugar_g: 2,
        id: 52,
    },
    {
        image: "./images/diet/chicken_soup.jfif",
        type: "nonvegeatarian",
        name: "chicken_soup",
        time: "dinner",
        calories: 36,
        carbohydrates_total_g: 3.6,
        cholesterol_mg: 10,
        fat_saturated_g: 0.5,
        fat_total_g: 1.5,
        fiber_g: 0.3,
        potassium_mg: 190,
        protein_g: 2.4,
        serving_size_g: 100,
        sodium_mg: 343,
        sugar_g: 0.5,
        id: 53,
    },
    {
        image: "./images/diet/turmeric milk.jfif",
        type: "vegeatarian",
        name: "turmeric milk",
        time: "bed time",
        calories: 75,
        carbohydrates_total_g: 5,
        cholesterol_mg: 10,
        fat_saturated_g: 3,
        fat_total_g: 4,
        fiber_g: 0,
        protein_g: 3.5,
        potassium_mg: 175,
        sodium_mg: 45,
        sugar_g: 5,
        serving_size_g: 100,
        id: 54,
    },
    {
        image: "./images/diet/basil_leaves_tea.webp",
        type: "vegeatarian",
        name: "basil_leaves_tea",
        time: "bed time",
        calories: 22,
        carbohydrates_total_g: 2.7,
        cholesterol_mg: 0,
        fat_saturated_g: 0,
        fat_total_g: 0.6,
        fiber_g: 1.6,
        potassium_mg: 295,
        protein_g: 3.2,
        serving_size_g: 100,
        sodium_mg: 4,
        sugar_g: 0.3,
        id: 55,
    },
    {
        image: "./images/diet/chamomile_tea.jfif",
        type: "vegeatarian",
        name: "chamomile_tea",
        time: "bed time",
        calories: 1,
        carbohydrates_total_g: 0.2,
        cholesterol_mg: 0,
        fat_saturated_g: 0,
        fat_total_g: 0,
        fiber_g: 0,
        potassium_mg: 9,
        protein_g: 0,
        serving_size_g: 100,
        sodium_mg: 1,
        sugar_g: 0,
        id: 56,
    },
];
export default DietData;
